(function($) {
	$(".tab-nav a").on("click", function(e) {
		e.preventDefault();
		$(".tab-nav a").removeClass('active');
		$(this).addClass('active');
		var target = $(this).data("target");
		$('.top50-listing-tabs .tab').removeClass('active');
		$('.'+target).addClass('active');
	});
	$(document).ready(function() {
		var tab = findGetParameter('tab');
		if(tab && tab.length) {
				$('html, body').animate({
				    scrollTop: $('#tab-anchor').offset().top - 100
				}, 20);
		}
	});
	function findGetParameter(parameterName) {
		var result = null,
		    tmp = [];
		location.search
		.substr(1)
		    .split("&")
		    .forEach(function (item) {
		    tmp = item.split("=");
		    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
		});
		return result;
	}
})(jQuery);
